function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/* eslint-disable no-unused-vars */
import './jquery_world'; // for custom $.tooltip function
import React, { Component, createRef } from 'react';
import { createRoot } from 'react-dom/client';
import Report from './report';
import SequenceModal from './sequence_modal';
import ErrorModal from './error_modal';

/**
 * Base component of report page. This component is later rendered into page's
 * '#view' element.
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Page = /*#__PURE__*/function (_Component) {
  function Page(props) {
    var _this;
    _classCallCheck(this, Page);
    _this = _callSuper(this, Page, [props]);
    _this.showSequenceModal = _this.showSequenceModal.bind(_this);
    _this.showErrorModal = _this.showErrorModal.bind(_this);
    _this.getCharacterWidth = _this.getCharacterWidth.bind(_this);
    _this.hspChars = /*#__PURE__*/createRef();
    _this.sequenceModal = /*#__PURE__*/createRef();
    _this.errorModal = /*#__PURE__*/createRef();
    return _this;
  }
  _inherits(Page, _Component);
  return _createClass(Page, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var job_id = location.pathname.split('/').pop();
      sessionStorage.setItem('job_id', job_id);
    }
  }, {
    key: "showSequenceModal",
    value: function showSequenceModal(url) {
      this.sequenceModal.current.show(url);
    }
  }, {
    key: "showErrorModal",
    value: function showErrorModal(errorData, beforeShow) {
      this.errorModal.current.show(errorData, beforeShow);
    }
  }, {
    key: "getCharacterWidth",
    value: function getCharacterWidth() {
      if (!this.characterWidth) {
        var $hspChars = $(this.hspChars.current);
        this.characterWidth = $hspChars.width() / 29;
      }
      return this.characterWidth;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      return /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx("div", {
          className: "mx-auto",
          children: /*#__PURE__*/_jsx(Report, {
            showSequenceModal: function showSequenceModal(_) {
              return _this2.showSequenceModal(_);
            },
            getCharacterWidth: function getCharacterWidth() {
              return _this2.getCharacterWidth();
            },
            showErrorModal: function showErrorModal() {
              return _this2.showErrorModal.apply(_this2, arguments);
            }
          })
        }), /*#__PURE__*/_jsx("pre", {
          className: "m-0 p-0 rounded-none border-0 bg-inherit whitespace-pre-wrap break-keep mt-1 pre-text tracking-wider",
          ref: this.hspChars,
          hidden: true,
          children: "ABCDEFGHIJKLMNOPQRSTUVWXYZ +-"
        }), /*#__PURE__*/_jsx("canvas", {
          id: "png-exporter",
          hidden: true
        }), /*#__PURE__*/_jsx(SequenceModal, {
          ref: this.sequenceModal,
          showErrorModal: function showErrorModal() {
            return _this2.showErrorModal.apply(_this2, arguments);
          }
        }), /*#__PURE__*/_jsx(ErrorModal, {
          ref: this.errorModal
        })]
      });
    }
  }]);
}(Component);
var root = createRoot(document.getElementById('view'));
root.render( /*#__PURE__*/_jsx(Page, {}));